import {StringDictionary} from '../types/dictionaries';

/**
 * Char map for slovak language
 */
export const SlovakCharmap: StringDictionary = 
{
    'áä': 'a',
    'éě': 'e',
    'í': 'i',
    'óô': 'o',
    'úů': 'u',
    'ý': 'y',
    'č': 'c',
    'ď': 'd',
    'ľĺ': 'l',
    'ň': 'n',
    'řŕ': 'r',
    'š': 's',
    'ť': 't',
    'ž': 'z',
};